<div class="row">
	<div class="col col-4"><span i18n="Common|Length">Length</span>:</div>
	<div class="col col-8">
		<app-numeric-textbox [value]="current.length" [disabled]="true"></app-numeric-textbox> mm
	</div>
</div>

<div class="row">
	<div class="col col-4">
		<span *ngIf="current.orientation == 'Horizontal'"><span i18n="Common|Location y">Location y</span>:</span>
		<span *ngIf="current.orientation == 'Vertical'"><span i18n="Common|Location x">Location x</span>:</span>
	</div>

	<div class="col col-8">
		<app-numeric-textbox #numLoc [value]="currentProfileLocation" [disabled]="true"></app-numeric-textbox> mm
	</div>
</div>

<div class="row">
	<div class="col col-4">
		<span i18n="Common|Delete">Delete</span>:
	</div>
	<div class="col col-8">
		<button kendoButton [svgIcon]="projectService.svgIcons.trashIcon" (click)="delete()" [disabled]="projectService.readOnly" class="medium"><span i18n="Common|Delete">Delete</span></button>
	</div>
</div>

<div *ngIf="projectService.showDebugInfo" class="testMode">
	<div class="row">
		<div class="col col-4">Mode:</div>
		<div class="col col-8">{{ current.mode }}</div>
	</div>
</div>

